import { useCallback } from 'react';
import { getColorsFromPalette } from '~/_shared/utils/colors/color.palette';
import {
  type ActiveBoundaryFillInfoEntities, getNoFillEntities, useGetBoundaryFillEntities,
} from '~/sidebar/sidebarApps/mapTools/boundary/hooks/useGetBoundaryFillEntities';
import type { BoundaryTerritoryGroup } from '~/store/boundaryTerritoryGroups/boundaryTerritoryGroups.state';

export const getBoundaryFillName = (entities: ActiveBoundaryFillInfoEntities): string => {
  if (entities.shortenedSubEntity) {
    return `${entities.shortenedMainEntity} > ${entities.shortenedSubEntity}`;
  }
  return entities.shortenedMainEntity;
};

export type BoundaryFillInfo = Readonly<{
  fillOrderNumber: number;
  backgroundColor: string;
  foregroundColor: string;
  entities: ActiveBoundaryFillInfoEntities;
  fillName: string;
  isNoFill: boolean;
}>;

export const useGetBoundaryFillInfo = () => {
  const getBoundaryFillEntities = useGetBoundaryFillEntities();

  const noFillEntities = getNoFillEntities();

  return useCallback((boundaryTerritoryGroup: BoundaryTerritoryGroup | null | undefined, index: number): BoundaryFillInfo => {
    const { background, foreground } = getColorsFromPalette(index);
    const entities = getBoundaryFillEntities(boundaryTerritoryGroup) ?? noFillEntities;
    const fillName = getBoundaryFillName(entities);

    return {
      fillOrderNumber: index,
      backgroundColor: background,
      foregroundColor: foreground,
      entities,
      fillName,
      isNoFill: entities === noFillEntities,
    };
  }, [getBoundaryFillEntities, noFillEntities]);
};
